import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/certifications/components/CertificationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/certifications/components/HeroSection.tsx");
